import React, { ReactElement } from 'react';
import {
  Grid as KendoGrid,
  GridColumn as Column
} from '@progress/kendo-react-grid';
import { DISPATCHER_BASE_GRID_PROPS } from './Types';

class BaseGrid extends React.Component<DISPATCHER_BASE_GRID_PROPS, {}> {
  render() {
    return (
      <div>
        <KendoGrid
          data={this.props.data}
          style={this.props.style}
          rowHeight={this.props.rowHeight}
          className={this.props.className}
          rowRender={this.props.rowRender}
        >
          {this.props.columns.map((item: any, index: number) =>
            (
              <Column
                key={index.toString()}
                field={item.field}
                title={item.title}
                width={item.width}
              />)
          )}

        </KendoGrid>
      </div>
    );
  }
}

export default BaseGrid;
